import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/analytics/pnl.md?raw';

const AnalyticsPnL: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default AnalyticsPnL;
